import { RelatorioRotaService } from './../../services/relatorio-rota.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { take } from 'rxjs/operators';
import { FileDownloadService } from '@services/file-download.service';
import { DateValidationMixin } from 'src/app/utils/date-validation.mixin';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { NgClass, AsyncPipe } from '@angular/common';
import { MatSuffix } from '@angular/material/form-field';
import { FieldErrorComponent } from '../../components/field-error/field-error.component';
import { SelectComponent } from '../../components/select/select.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-relatorio-rota',
    templateUrl: './relatorio-rota.component.html',
    styleUrls: ['./relatorio-rota.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BreadcrumbComponent, FormsModule, ReactiveFormsModule, DateMaskDirective, MatDatepickerInput, NgClass, MatDatepickerToggle, MatSuffix, MatDatepicker, FieldErrorComponent, SelectComponent, FooterComponent, AsyncPipe, UsuarioPermissaoPipe]
})
export class RelatorioRotaComponent extends DateValidationMixin implements OnInit {

  public listaDepartamento: any;
  public loadingGenerico: boolean = false;
  public formulario: UntypedFormGroup;
  public mensagemErro: string;
  public empresa: any = localStorage.idEmpresaLogada;
  public resources: any;

  obj: any = {
    dsId_depart_edp: 'USUÁRIOS DE TODOS DEPARTAMENTOS',
    dsfl_roteirizacao: 'TODOS',
    dsfl_status_eus: 'TODOS',
    dstipoRelatorio: 'Lista de usuários roteirizados',
    dtFinal: '2020-10-22T14:36:20.752Z',
    dtInicio: '2020-10-01T14:36:20.752Z',
    flRoteirizacao: 'T',
    flStatus: 'T',
    idDepartamento: 0,
    tipoRelatorio: 0
  };

  constructor(
    public formularioBuilder: UntypedFormBuilder,
    private readonly relatorioRota: RelatorioRotaService,
    private readonly Toastr: ToastrService,
  ) {
    super();
    this.construirFormulario();
  }

  ngOnInit(): void {
    this.getAllDepartamentos();
  }

  construirFormulario() {
    this.formulario = this.formularioBuilder.group({
      tipoRelatorio: ['', Validators.compose([Validators.required])],
      dataInicial: ['', Validators.compose([Validators.required])],
      dataFinal: ['', Validators.compose([Validators.required])],
      situacaoUsuario: ['T'],
      situacaoRoteirizacao: ['T'],
      departamento: [0, []],
    });
  }

  public listar() {
    if (this.dataInicialError || this.dataFinalError) return;

    this.loadingGenerico = true;
    this.obj.idDepartamento = this.formulario.value.departamento;
    this.obj.flRoteirizacao = this.formulario.value.situacaoRoteirizacao;
    this.obj.dsfl_status_eus = this.formulario.value.situacaoUsuario;
    this.obj.dtFinal = this.formulario.value.dataFinal;
    this.obj.dtInicio = this.formulario.value.dataInicial;
    this.obj.tipoRelatorio = this.formulario.value.tipoRelatorio;

    this.relatorioRota.postListarDepartamentos(this.empresa, this.obj).subscribe({
      next: (success) => {
        this.loadingGenerico = false;
        const fileTitle = this.formulario.value.tipoRelatorio == '1'
          ? 'Cobranca_roteirizacao.csv'
          : 'Lista_usuarios_roteirizados.csv';
        FileDownloadService.download([success.body as BlobPart], fileTitle);
      },
      error: (error) => {
        this.loadingGenerico = false;
        if (error.error.status == 400) {
          this.mensagemErro = error.error.mensagem;
          this.Toastr.error(this.mensagemErro);
        }
        console.error(error);
      }
    });
  }

  getAllDepartamentos() {
    this.relatorioRota.getDepartamentos(this.empresa).pipe(take(1)).subscribe({
      next: (success: any) => { this.listaDepartamento = success.response; },
      error: (error) => {
        this.Toastr.error('Erro ao encontrar departamentos');
        console.error(error);
      }
    });
  }

  // Override para adicionar validação de 90 dias
  onDataInicialPedido(): void {
    super.onDataInicialPedido();
    const dataInicio = moment(this.dataEmissaoInicio);
    const dataFinal = moment(this.dataEmissaoFim);
    if (dataFinal.isAfter(dataInicio.add(90, 'days'))) {
      this.dataFinalError = true;
      this.dataFinalMessageError = 'Favor pesquisar período menor que 90 dias.';
    }
  }
}
